export const ItemTypes = {
  FOOD: 'a',
  GLASS: 'a',
  PAPER: 'a',
}
